// The header bar's chrome, the section nav's reveal, and the country button's
// app hook.
//
// THE BAR NO LONGER RETRACTS. It used to hide on the way down and come back on
// an upward scroll or shortly after scrolling stopped — a behaviour argued over
// at length here and tuned to 300ms by feel.
//
// Craig retired it on 2026-09-23, having lived with it: "it feels somewhat
// distracting and can feel like you 'lose' the menu sometimes." That is the
// only kind of evidence that settles a question like this one, and it is the
// same kind that brought the behaviour back in the first place. The menu is now
// simply there.
//
// What replaced it for the home page is the section nav, which starts hidden
// and arrives once the hero is behind you — motion that happens once, where the
// old behaviour happened on every change of direction.
(function () {
  if (window.__pruvitHeader) return;
  window.__pruvitHeader = true;

  var header = document.querySelector('[data-pruvit-gnav]');
  if (!header) return;

  // The group is the sticky element; the bars inside it are not. Mark it and
  // publish the referrer bar's real height, which is how far the group sits
  // above the viewport when pinned — that bar's copy can wrap, so it is
  // measured rather than assumed.
  var group = header.closest('#header-group') || header.parentElement.parentElement;
  function measureGroup() {
    if (!group) return;
    group.classList.add('header-group-sticky');
    var topbar = group.querySelector('[data-pruvit-rbar]');
    var bar = topbar ? topbar.closest('.shopify-section') : null;
    var height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pruvit-topbar-h', height + 'px');

    // --pruvit-snav-h is deliberately NOT published here any more. The rail
    // arrives after the hero and pins over content that is already laid out,
    // so it contributes nothing to layout — and measuring it once it is open
    // would publish 51px into .pruvit-under-chrome and shift every band below
    // the first one, mid-scroll. The section declares a constant zero and that
    // is the whole of it.
  }
  measureGroup();
  window.addEventListener('resize', measureGroup, { passive: true });
  window.addEventListener('load', measureGroup);

  // The referrer bar now ships visible at its full height, so the measure above
  // is already right at init — but the bar still changes size after it: it
  // collapses to nothing on a store where MV Qore cannot answer, and the "has"
  // state swaps in a name that can rewrap. Neither is knowable on a timer, and
  // this also covers the brand font landing, which the resize listener does
  // not see.
  if (group && window.ResizeObserver) {
    var rbar = group.querySelector('[data-pruvit-rbar]');
    var rbarSection = rbar ? rbar.closest('.shopify-section') : null;
    if (rbarSection) new ResizeObserver(measureGroup).observe(rbarSection);
  }

  // Horizon does not scroll the document on desktop. From 990px up
  // .page-wrapper is `height: 100dvh; overflow-y: auto` and the page scrolls
  // inside it; below that the window scrolls as usual. So the scroller is
  // found rather than assumed, and found again on resize, because crossing
  // that breakpoint moves it.
  var scroller = null;

  function findScroller() {
    var node = header.parentElement;
    while (node && node !== document.body) {
      // No scrollHeight check: a deferred script runs before layout has
      // settled, and at that moment the wrapper may not yet overflow — which
      // made this fall back to window and silently do nothing. An ancestor
      // with overflow-y auto or scroll is the scroller whether or not it has
      // content to scroll yet.
      var overflowY = getComputedStyle(node).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return node;
      }
      node = node.parentElement;
    }
    return window;
  }

  function offset() {
    return scroller === window ? window.scrollY : scroller.scrollTop;
  }

  // The section nav, which is not on every page.
  var snav = group ? group.querySelector('[data-pruvit-snav]') : null;
  var hero = document.querySelector('[data-pruvit-hero], .pruvit-hero');

  function onScroll() {
    // Chrome only once something is actually passing underneath.
    header.classList.toggle('is-scrolled', offset() > 10);

    // The rail arrives when the hero is behind you and goes away again when it
    // is not. Measured off the hero itself rather than a scroll offset, so it
    // is right whichever element is scrolling.
    //
    // With no hero — every page that is not the home page — a rail that exists
    // is simply shown, because there is nothing for it to wait for.
    if (snav) {
      snav.classList.toggle('is-on', hero ? hero.getBoundingClientRect().bottom <= 0 : true);
    }
  }

  function bind() {
    var next = findScroller();
    if (next === scroller) return;
    if (scroller) scroller.removeEventListener('scroll', onScroll);
    scroller = next;
    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  bind();
  window.addEventListener('resize', bind, { passive: true });
  // Layout is settled by load, so re-resolve then too.
  window.addEventListener('load', bind);

  // Orbe owns the country and language modal; this button only opens it.
  // lastModalTriggerButton is how Orbe knows where to put focus back — it
  // reads that global and never sets it, so the trigger has to introduce
  // itself or a keyboard user is dropped on <body> when the modal closes.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pruvit-country]');
    if (!button) return;
    event.preventDefault();

    if (typeof window.mdApp_openAndRefreshModal !== 'function') {
      // The app embed is off or failed to load. Shopify's own localization
      // form is the fallback, and it lives on the cart page.
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'cart';
      return;
    }

    window.lastModalTriggerButton = button;
    window.mdApp_openAndRefreshModal();
  });
})();
